module.exports = __webpack_public_path__ + "img/background04.f55f9868.jpg";